const errors = {
  1: {
    default: 'Dogodila se greška',
    sendOtpCode: {
      MtmLimitOtpCodeRequestsError: 'Iskoristio si maksimalan broj slanja u roku od jednog sata. Pokušaj kasnije.',
      MtmCustomerNotFoundError: 'Uneli ste nepostojeći broj telefona.',
      ValidationError: 'Neodgovarajući format. Pokušajte ponovo.',
      MtmSendSmsError: 'Došlo je do serverske greske. Molim vas pokušaj ponovo.'
    },
    verifyOtpCode: {
      MtmLimitOtpCodeRequestsError: 'Uneti kod nije validan. Pošalji zahtev za novi kod.',
      MtmInvalidOtpCodeError: 'Uneti OTP kod nije validan. Pokušajte ponovo.',
      MtmOtpCodeExpiredError: 'Uneti kod nije validan. Pošalji zahtev za novi kod.',
      ValidationError: 'Uneti kod nije validan. Pošalji zahtev za novi kod.'
    },
    verifyCustomer: {
      MtmCustomerNotFoundError: 'Pogrešna šifra korisnika ili broj računa.'
    }
  },
  2: {}
}

function getLanguage () {
  const lsLang = localStorage.getItem('site-language')
  if (lsLang) {
    return lsLang
  } else {
    return document.getElementById('HybrisSelfCareB2CComponentLanguage').value || '1'
  }
}

export function getApiResponse (apiSection, code) {
  const lang = getLanguage()
  try {
    return errors[lang][apiSection][code] || errors[lang].default
  } catch (e) {
    return errors[lang].default
  }
}
